// extracted by mini-css-extract-plugin
export default {"base":"Caption_base__2oDZQ","isLarge":"Caption_isLarge__jvkXA","isRequired":"Caption_isRequired__OqGl+","isError":"Caption_isError__6ow4o"};